import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    rootBadge: {
        height: 20,
        borderRadius: 10,
        color: "#FFF",
        background: "rgba(48, 73, 103, 0.8)",
        fontSize: 10,
        marginRight: 8,
        paddingRight: 8,
        paddingLeft: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "default"
    }
});

const RolesBadges = ({ roles }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
          {(roles && roles.length>0) &&
            roles.map(
              ({ name }) =>
              <div className={classes.rootBadge}>
                <span>{name}</span>
              </div>
            )
          }            
        </div>
    );
};

export default RolesBadges;
